import { Comment } from '@components-clean/core/comments-side-bar/components/cards/comment-card';
import { getComments_OpraQueries_comments_Comment } from '@queries/generated/common.generated';

export const mapCommentResponseToComment = (comment: getComments_OpraQueries_comments_Comment): Comment => ({
    id: comment.id,
    content: comment.content,
    open: comment.open,
    createdAt: comment.created,
    createdById: comment.createdBy?.id ?? '',
    createdBy: `${comment.createdBy?.firstName ?? ''} ${comment.createdBy?.lastName ?? ''}`,
    version: comment.version,
    updatedById: comment.updatedBy!.id,
    replies: comment.replies.map((reply) => ({
        id: reply!.id,
        createdAt: reply!.created,
        createdById: reply!.createdBy?.id ?? '',
        createdBy: `${reply!.createdBy?.firstName ?? ''} ${reply!.createdBy?.lastName ?? ''}`,
        content: reply!.content,
        version: reply!.version,
    })),
});
